// ** React Imports
import { Link } from 'react-router-dom'
import { useContext } from 'react'

// ** Third Party Components
import { Settings, Users, Tool, Book, Layers, UploadCloud } from 'react-feather'
import { useTranslation } from 'react-i18next'

// ** Contexts
import { AbilityContext } from '@src/utility/context/Can'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap'

const ConfigDropdown = () => {
  const { t } = useTranslation()

  const ability = useContext(AbilityContext)

  for (const ab of ability.$) {
    if ((ab.action === "update" && ab.subject === "settings") || (ab.action === "create" && ab.subject === "user")) {
        return (
            <UncontrolledDropdown tag='li' className='dropdown-config nav-item'>
              <DropdownToggle href='/' tag='a' className='nav-link dropdown-config-link' onClick={e => e.preventDefault()}>
                <Settings className='ficon' />
              </DropdownToggle>
              <DropdownMenu end>
              <DropdownItem tag={Link} to='/config-users'>
                  <Users size={14} className='me-75' />
                  <span className='align-middle'>{t("Users")}</span>
                </DropdownItem>
                <DropdownItem tag={Link} to='/config-client'>
                  <Tool size={14} className='me-75' />
                  <span className='align-middle'>{t("Settings")}</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
        )
    }
  }

  return ("")
}

export default ConfigDropdown
